import { hasCriticalErrors } from '@/lib/utils';
import { isDealItemCategoryUpdating } from '@/lib/utils/updating-fields';
import { effectiveValidationErrorsAtom } from '@/states/effective-validation-errors.state';
import { productsState } from '@/states/products.state';
import { atom } from 'jotai';

/** True when at least one selected deal item has a critical validation error. */
export const hasProductErrorsAtom = atom<boolean>((get) => {
  const products = get(productsState);
  const effectiveErrors = get(effectiveValidationErrorsAtom);
  return products.some((product) => {
    if (!product.activeVersion.isSelected) return false;
    if (isDealItemCategoryUpdating(product)) return true;
    const errors = effectiveErrors.get(product.id);
    return errors != null && hasCriticalErrors(errors);
  });
});
